import React from "react";
import Event from "./Event";
import events from "../../utils/events";
import { shapes2 } from "../../utils/images";
import "./events.scss";
import Masonry, { MasonryBox } from "../../Layout/Masonry/Masonry";

const Events = () => {
	return (
		<main
			className="events"
			style={{
				backgroundImage: `url(${shapes2})`,
			}}
		>
			<section className="events-head">
				<h1>Events</h1>
			</section>
			<section className="events-body">
				<Masonry>
					{events.map((event, index) => (
						<MasonryBox key={index}>
							<Event {...event} />
						</MasonryBox>
					))}
				</Masonry>
			</section>
		</main>
	);
};

export default Events;
